'use strict';
import angular from 'angular';
import adScheduleHtmlUrl from './views/adSchedule.html';

var app = angular.module('app.adSchedule', []);
app.$inject = ['$ioAlert'];

app.component('adSchedule', {
    bindings: {
        showActions: '=',
        adScheduleRanges: '='
    },
    templateUrl: adScheduleHtmlUrl,

    controller: function ($ioAlert) {
        var self = this;

        self.clockType = "twentyFour";
        self.hoursRange = [];

        self.daysList = [
            { value: "ALL_DAYS", label: "All days" },
            { value: "MONDAY_TO_FRIDAY", label: "Mondays - Fridays" },
            { value: "SATURDAY_SUNDAY", label: "Saturdays - Sundays" },
            { value: "MONDAY", label: "Mondays" },
            { value: "TUESDAY", label: "Tuesdays" },
            { value: "WEDNESDAY", label: "Wednesdays" },
            { value: "THURSDAY", label: "Thursdays" },
            { value: "FRIDAY", label: "Fridays" },
            { value: "SATURDAY", label: "Saturdays" },
            { value: "SUNDAY", label: "Sundays" }
        ];

        self.groupedDayMap = {
            ALL_DAYS: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],
            MONDAY_TO_FRIDAY: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"],
            SATURDAY_SUNDAY: ["SATURDAY", "SUNDAY"]
        };

        self.generateTimeRanges = function (format = 'twentyFour') {
            const result = [];
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 15) {
                    const hh = String(h).padStart(2, '0');
                    const mm = String(m).padStart(2, '0');
                    const value = `${hh}:${mm}`;
                    let label;
                    if (format === 'twelve') {
                        const hour = h % 12 || 12;
                        const ampm = h < 12 ? 'AM' : 'PM';
                        label = `${String(hour).padStart(2, '0')}:${mm} ${ampm}`;
                    } else {
                        label = value;
                    }
                    result.push({ value, label });
                }
            }
            return result;
        };

        self.switchClockType = function () {
            self.hoursRange = self.generateTimeRanges(self.clockType);
        };

        self.addNewRow = function () {
            const newSlot = {
                originalGroup: "ALL_DAYS",
                startTime: "00:00",
                endTime: "00:00"
            };
            self.adScheduleRanges.ui.push(newSlot);
            self.updateBackendFromUI();
        };

        self.deleteTimeSlot = function (slot, index) {
            self.adScheduleRanges.ui.splice(index, 1);
            self.updateBackendFromUI();
        };

        self.updateGroupedTime = function (item, index) {
            self.adScheduleRanges.ui[index] = item;
            self.updateBackendFromUI();
        };

        self.updateBackendFromUI = function () {
            const backend = [];
            self.adScheduleRanges.ui.forEach(slot => {
                const groupKey = slot.originalGroup || slot.dayOfWeek;
                const days = self.groupedDayMap[groupKey] || [groupKey];
                days.forEach(day => {
                    backend.push({
                        dayOfWeek: day,
                        startTime: slot.startTime,
                        endTime: slot.endTime
                    });
                });
            });
            self.adScheduleRanges.backend = backend;
        };

        self.getExpandedScheduleForBackend = function () {
            return self.adScheduleRanges.backend || [];
        };

        self.resetComponent = function () {
            self.clockType = "twentyFour";
            self.hoursRange = self.generateTimeRanges("twentyFour");
            self.adScheduleRanges = {
                ui: [],
                backend: []
            };
        };

        self.groupFlatAdSchedule = function (flatArray) {
            var ui = [];
            var backend = [];

            if (!flatArray || flatArray.length === 0) return { ui, backend };

            const days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            const weekdays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
            const weekends = ['SATURDAY', 'SUNDAY'];

            const isSameDays = (a, b) => _.isEqual([...a].sort(), [...b].sort());

            // Group by time range
            const timeGroups = _.groupBy(flatArray, slot => slot.startTime + '-' + slot.endTime);

            _.each(timeGroups, (slots, key) => {
                const slotDays = _.map(slots, 'dayOfWeek');
                const [startTime, endTime] = key.split('-');

                if (isSameDays(slotDays, days)) {
                    ui.push({ originalGroup: 'ALL_DAYS', startTime, endTime });
                } else if (isSameDays(slotDays, weekdays)) {
                    ui.push({ originalGroup: 'MONDAY_TO_FRIDAY', startTime, endTime });
                } else if (isSameDays(slotDays, weekends)) {
                    ui.push({ originalGroup: 'SATURDAY_SUNDAY', startTime, endTime });
                } else {
                    backend.push(...slots);
                }
            });

            return { ui, backend };
        };

        self.initComponent = function () {
            if (typeof self.adScheduleRanges === 'string') {
                try {
                    self.adScheduleRanges = JSON.parse(self.adScheduleRanges);
                } catch (e) {
                    console.warn("Invalid JSON in adScheduleRanges");
                    self.adScheduleRanges = [];
                }
            }

            if (!self.adScheduleRanges || typeof self.adScheduleRanges !== 'object' || Array.isArray(self.adScheduleRanges)) {
                var flatArray = Array.isArray(self.adScheduleRanges) ? self.adScheduleRanges : [];
                var grouped = self.groupFlatAdSchedule(flatArray);
                self.adScheduleRanges = {
                    ui: grouped.ui,
                    backend: self.adScheduleRanges
                };
            } else {
                self.adScheduleRanges = {
                    ui: self.adScheduleRanges.ui || [],
                    backend: self.adScheduleRanges.backend || []
                };
            }
            self.showAdScheduleView = !self.showActions;
            self.enableEditMode = !!self.showActions;

            self.switchClockType();
        };

        self.initComponent();
    }
});
